import { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

import PrerequisiteAlert from "../PrerequisiteAlert";

const AssignTeamModal = ({ show, onHide, currentUser, partnerTeams, teamsKnown = true, onSubmit, serverFieldErrors, onClearServerFieldError, onAddTeam }) => {
  const hasTeams = (partnerTeams?.length ?? 0) > 0;
  const missingTeam = teamsKnown && !hasTeams;
  const [teamId, setTeamId] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setTeamId(currentUser?.team_id ?? "");
      setError(null);
    }
  }, [show, currentUser]);

  const teamIdServerError = serverFieldErrors?.team_id ?? null;
  const displayError = error || teamIdServerError;

  const clearErrors = () => {
    setError(null);
    if (teamIdServerError && onClearServerFieldError) {
      onClearServerFieldError("team_id");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!teamsKnown || !hasTeams) return;
    if (!teamId) {
      setError("Please select a team.");
      return;
    }
    setSubmitting(true);
    try {
      await onSubmit(teamId);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Assign Team: {currentUser?.full_name}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit} noValidate>
        <Modal.Body>
          {missingTeam && (
            <PrerequisiteAlert
              message="No teams exist yet. Add a team before assigning this user."
              actionLabel="Add team"
              onAction={onAddTeam}
            />
          )}
          <Form.Group className="mb-2">
            <Form.Label>Team</Form.Label>
            <Form.Select
              value={teamId}
              onChange={(event) => {
                setTeamId(event.target.value);
                clearErrors();
              }}
              isInvalid={!!displayError}
            >
              <option value="">Select a team</option>
              {partnerTeams?.map((team) => (
                <option key={team.id} value={team.id}>{team.name}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{displayError}</Form.Control.Feedback>
            <Form.Text className="text-muted">
              Moves this user to the selected team. Their wallet stays active.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={submitting}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={submitting || !teamsKnown || !hasTeams}
            title={missingTeam ? "Add a team first." : undefined}
          >
            {submitting ? <Spinner animation="border" size="sm" className="me-2" /> : null}
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AssignTeamModal;
